__turbopack_context__.v({
  "className": "caveat_38d498fa-module__-znfsW__className",
});
